<template>
	<span class="dropdown-menu-sem-graca" :id="`dropdown-${name}`">
		<label :for="name" :class="[name, tooltip.text ? 'tooltip' : '', tooltip.text && tooltip.type ? tooltip.type : '' ]" :data-tooltip-content="tooltip.text">
			{{ text }}
			<span :class="['download-status', loading ? 'downloading' : '']"></span>
			<span class="fas fa-caret-down"></span>
		</label>

		<input :id="name" type="checkbox" />

		<ul>
			<li v-for="(item, i) in items" :key="i">
				<a v-if="typeof item.handler === 'function'" @click="item.handler(); close()" href="javascript:void(0)">{{ item.text }}</a>
				<router-link v-if="item.route" :to="item.route">{{ item.text }}</router-link>
			</li>
		</ul>
	</span>
</template>

<script>
export default {
	name: 'DropdownMenu',
	props: {
		name: {
			type: String,
			default: `menu-${parseInt(Math.random() * 1000000000000)}`
		},
		text: {
			type: String,
			default: 'Dropdown menu super ultra mega plus basic'
		},
		loading: {
			type: Boolean,
			default: false
		},
		tooltip: {
			type: Object,
			default: function () { return {} }
		},
		items: {
			type: Array,
			default: function () { return [] }
		}
	},
	created () {
		window.removeEventListener('click', this.closeDropdownOnOutsideClick)
		window.addEventListener('click', this.closeDropdownOnOutsideClick)
	},
	methods: {
		closeDropdownOnOutsideClick (evt) {
			const menu = evt.target.closest(`#dropdown-${this.name}`)
			if (!menu) {
				this.close()
			}
		},
		close () {
			document.querySelector(`input#${this.name}`).checked = false
		}
	}
}
</script>

<style lang="scss" scoped>
	span.dropdown-menu-sem-graca {
		position: relative;

		> label {
			position: relative;
			display: inline-block;
			padding: 10px 45px 10px 30px;
			border-radius: 3px;
			font-family: $font-family-alternative;
			background: $success-color;
			color: $inputs-color;
			text-decoration: none;
			font-size: .9em;
			cursor: pointer;

			&:hover {
				background-color: #2952ab
			}

			.fas {
				position: absolute;
				right: 0px;
				top: 5px;
				padding: 10px 15px;
			}

			.download-status.downloading {
				display: inline-block;
				margin-left: 5px;
				animation: fa-spin 2s linear infinite;

				&::before {
					content: '\f110';
					font-family: 'Font Awesome 5 Free';
					font-weight: 900;
				}
			}
		}

		input {
			position: absolute;
			top: 0;
			left: 0;
			pointer-events: none;
			opacity: 0;

			~ ul {
				position: absolute;
				grid-template-columns: 1fr;
				top: 35px;
				left: 0;
				z-index: 1;
				display: none;
				min-width: 100%;
				max-width: 100vw;
				width: max-content;
				max-height: 300px;
				overflow-y: auto;
				padding: 15px 0;
				border-radius: $border-radius;
				box-shadow: 1px 1px 1px #0003;;
				background-color: #2952AB;
				color: $inputs-color;
				font-size: .9em;

				li {
					a {
						display: inline-block;
						width: 100%;
						height: 46px;
						padding: 10px 32px;
						text-align: center;
						color: inherit;
						text-decoration: inherit;
						transition: background-color .167 linear;

						&:hover {
							background-color: #FFF3;
						}
					}
				}
			}

			&:checked ~ ul {
				display: block;
			}
		}

		/* ícone de carregamento usado nos botões dos menus de exportação */
		.download-status.downloading {
			display: inline-block;
			margin-left: 5px;
			animation: fa-spin 2s linear infinite;

			&::before {
				content: '\f110';
				font-family: 'Font Awesome 5 Free';
				font-weight: 900;
			}
		}
	}
</style>
